import { Avatar, Grid } from "@mui/material";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { useSession } from "providers/SessionProvider";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { RootPaths } from "routes/RootRouter";
import { resolveAuthor } from "views/knowledge/components/card/behaviors/common/DefaultAuthor";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

export const AuthorDialog = () => {
    const { pub, otherInfo } = useCardContext();
    const { t } = useTranslation("knowledge");
    const session = useSession();

    var author = resolveAuthor(pub, t, session.user.userId);

    const RenderAuthorName = (
        <MprcFeedTypography variant="authorPrimary" component="div" noWrap>
            <span title={author.name}>{author.name}</span>
            {
                pub.supervisor != null &&
                <span> ({t("Feed.Card.Common.EditedBySupervisorText")})</span>
            }
        </MprcFeedTypography>
    );

    return (
        <Grid container justifyContent="center" alignItems="center" spacing={1} width="100%">
            {!pub.isAnonymous &&
                <Grid>
                    <Avatar src={author.thumbnailUrl} title={author.name} />
                </Grid>
            }
            <Grid size="grow" overflow="hidden">
                {(pub.institutional != null || otherInfo.enableAuthorLink === false || pub.isAnonymous)
                    ? RenderAuthorName
                    : (
                        <Link
                            onClick={otherInfo?.onBeforeLinkClick == undefined ? undefined : otherInfo.onBeforeLinkClick()}
                            to={RootPaths.BuildUserProfile(pub.author.userId)}
                        >
                            {RenderAuthorName}
                        </Link>
                    )
                }

                <MprcFeedTypography variant="authorSecondary" component="div" noWrap>
                    <span>{author.actionFormatted}</span>
                    {
                        !pub.isDraft && pub.channel?.name &&
                        <>
                            <span>&nbsp;{t("shared:Literal.At")}&nbsp;</span>
                            {
                                otherInfo?.enableChannelLink === true
                                    ? (
                                        <Link
                                            onClick={otherInfo?.onBeforeLinkClick == undefined ? undefined : otherInfo.onBeforeLinkClick()}
                                            to={KnowledgePaths.FeedChannel(pub.channel.id)}
                                        >
                                            <b>{pub.channel.name}</b>
                                        </Link>
                                    )
                                    : <b>{pub.channel.name}</b>
                            }
                        </>
                    }
                </MprcFeedTypography>
            </Grid>
        </Grid>
    );
};
